import { useMutation, useQueryClient } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { UpdateProcessAccessSettingsDTO } from '@app/models/orders';
import Api from '@app/services/api';

interface IParams {
  uid: string;
  data: UpdateProcessAccessSettingsDTO;
}

export const useUpdateAccessSettingsGroup = () => {
  const client = useQueryClient();
  const commonT = useTranslation(NSKeys.common);

  return useMutation({
    mutationFn: async ({ uid, data }: IParams) => {
      await Api.orders.putAccessSettingsGroup(uid, data);
    },
    onSuccess: async () => {
      message.open({
        type: 'success',
        content: commonT.t('dataPatchSuccess'),
      });
      await client.invalidateQueries(['getProcessAccessSettings']);
    },
    onError: async () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
      await client.invalidateQueries(['getProcessAccessSettings']);
    },
  });
};
